function pad(value) {
	return String(value).padStart(2, "0");
}

export function getTodayLocalDateInputValue() {
	const now = new Date();
	return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

export function toDateInputValue(value) {
	if (!value) return "";
	if (typeof value === "string") return value.slice(0, 10);

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "";

	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
